import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Sun from "../sun/sun";
import "./header.css";
import { Icon } from "antd";
import { actions } from "../../store/index";

const togglePanel = () => {
  actions.toggleInfo("ddd");
};

const InfoToggle = ({ infoToggle }) => (
  <div className="infoPanel">
    {infoToggle ? (
      <Icon type="right-circle-o" onClick={togglePanel} />
    ) : (
      <Icon type="left-circle-o" onClick={togglePanel} />
    )}
  </div>
);

// const OptionSelect = props => (
//   <Select
//     value={props.value.toString()}
//     style={{ width: 240 }}
//     onChange={props.onChange}
//   >
//     {props.options.map(e => (
//       <Select.Option key={e.id.toString()} value={e.id.toString()}>
//         {e.desc}
//       </Select.Option>
//     ))}
//   </Select>
// );

export class Header extends Component {
  static propTypes = {
    title: PropTypes.string,
    infoToggle: PropTypes.bool.isRequired
  };

  render() {
    const { title } = this.props;
    return (
      <div className="App-header">
        <div className="header-title">{title}</div>
        <Sun /> <InfoToggle infoToggle={this.props.infoToggle} />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/header.js